import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const names = ['Carlos', 'María', 'Juan', 'Ana', 'Pedro', 'Lucía', 'Diego', 'Sofía', 'Andrés', 'Valentina', 'Roberto', 'Carmen', 'Miguel', 'Laura', 'Fernando'];
const locations = ['Buenos Aires, Argentina', 'CDMX, México', 'Madrid, España', 'Bogotá, Colombia', 'Lima, Perú', 'Santiago, Chile', 'Montevideo, Uruguay', 'Quito, Ecuador', 'San José, Costa Rica', 'Barcelona, España'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    location: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomLocation = locations[Math.floor(Math.random() * locations.length)];
      setCurrentBuyer({
        name: randomName,
        location: randomLocation
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimeout = setTimeout(showPopup, 5000);
    const intervalId = setInterval(() => {
      if (!isVisible) {
        const delay = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
        setTimeout(showPopup, delay);
      }
    }, 35000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(intervalId);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-159">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white border border-warm-400 rounded-xl p-4 shadow-xl max-w-xs" data-id="element-160">
          <div className="flex items-start gap-3" data-id="element-161">
            <div className="bg-green-100 rounded-full p-1 mt-1" data-id="element-162">
              <CheckCircle2Icon className="w-5 h-5 text-green-600" data-id="element-163" />
            </div>
            <div data-id="element-164">
              <p className="text-sm text-warm-900 font-medium" data-id="element-165">
                <span className="font-bold" data-id="element-166">{currentBuyer.name}</span> de{' '}
                {currentBuyer.location}
              </p>
              <p className="text-xs text-warm-700 mt-1" data-id="element-167">
                acaba de comprar este producto.
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}